import axios from "axios";
import Config from "../Config";
import BaseServiceV2 from "./BaseServiceV2";
import ApiUrl from './ApiUrl';

class AuthServicev2 extends BaseServiceV2 {

    constructor() {
        super(ApiUrl.EbasvurCoreDomain + ApiUrl.controller.MasterUser);
    }



    async login(username, password) {
        const response = await this.easyPost(ApiUrl.auth.authenticate, {
            username: username,
            password: password
        });
        return response.resultObject;
    }

    async loginSessionKey(sessionKey) {
        const response = await this.easyPost(ApiUrl.auth.authenticate, {
            sessionKey: sessionKey,
        });
        return response.resultObject;
    }

    async getAuthorizedTenants(token) {
        const response = await this.easyPost(ApiUrl.auth.listAuthorizedTenants, null, token);

        return response.resultObject;
    }

    async login4Tenant(tenantGuid,token) {
        const response = await this.easyPost(ApiUrl.auth.authenticate4TenantToken, {
            guid: tenantGuid,
        },token);
        return response.resultObject;
    }

    async getbyToken(token) {
        const response = await this.fullPathPost(ApiUrl.auth.getbyToken, null,token);
        return response.resultObject;
    }



    async refresh(refreshToken) {
        const form = new URLSearchParams();
        form.append("grant_type", "refresh_token");
        form.append("refresh_token", refreshToken);


        const response = await fetch(Config.API_URL + this.path, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: form

        });

        return await response.json();
    }

    async getAccount(accessToken) {
        try {
            const response = await axios.get(`${Config.API_URL}/auths/account`,
                {
                    timeout: 60000,
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Accept': 'application/json'
                    }
                }
            );

            return response.data.resultObject;
        } catch (e) {
            return null;
        }
    }

}

const authServicev2 = new AuthServicev2();

export default authServicev2;
